import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from 'react-router-dom'

import '../assets/styles/ItemFilterCanva.css'
export default function ItemFilterCanva(props) {

    return (
        <div className="itemFilterCanva">
            <Offcanvas 
                className="item-filter-canva" 
                data-bs-theme="dark" 
                scroll={true} 
                backdrop={false} 
                onHide={() => props.setitemfiltercanvavisible(false)}
                show={props.itemfiltercanvavisible}
                {...props}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title className='title fw-bold'>Item Filter</Offcanvas.Title>
                </Offcanvas.Header>
                
                    
            </Offcanvas>
        </div>
    )
}